var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/file-transfer-customer/file-transfer-customer.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _wrapper\" id=\"file-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fileId"), env.opts.autoescape);
output += "\">\n  <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _block\">\n    <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _info\" title=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\">\n      <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _icon -";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "\"></div>\n      <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _name\">\n        <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _name-ruler\">\n          ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        </div>\n      </div>\n      <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _size\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "size"), env.opts.autoescape);
output += "</div>\n    </div>\n    <a\n      title=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\"\n      target=\"_blank\"\n      rel=\"noopener noreferrer\"\n      ";
if(runtime.contextOrFrameLookup(context, frame, "downloadUrl")) {
output += "\n        href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "downloadUrl"), env.opts.autoescape);
output += "\"\n        class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _download\"\n      ";
;
}
else {
output += "\n        href=\"javascript:void(0)\"\n        class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _download -hidden\"\n      ";
;
}
output += "\n    ></a>\n  </div>\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "hideProgress")) {
output += "\n  <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _progress\">\n    <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _progressBar\">\n      <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _progressPercent\">\n      </div>\n    </div>\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "disableCancelUpload")) {
output += "\n    <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "blockClass"), env.opts.autoescape);
output += " _cancel-button\" data-file-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fileId"), env.opts.autoescape);
output += "\">\n    ";
;
}
output += "\n    </div>\n  </div>\n  ";
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/file-transfer-customer/file-transfer-customer.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/file-transfer-customer/file-transfer-customer.html
// module id = 384
// module chunks = 0 1